import script from "./TyreLabelingHeaderCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./TyreLabelingHeaderCell.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__